import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectProductTypes = (state: RootState) =>
  sortBy(state.productTypes.productTypes, 'name');

export const selectActiveProductTypes = (state: RootState) =>
  sortBy(
    state.productTypes.productTypes.filter(x => x.active),
    'name'
  );
export const selectProductTypeErrors = (state: RootState) =>
  state.productTypes.errors;
